import BaseAPI from './BaseAPI';

export class ActivityAPI extends BaseAPI {

	// `type` is the entity the feed belongs to — see ACTIVITY_TYPES in activity.constants.
	async getForObject(type, objectId) {
		return this.request(`/-/activity/${type}/${objectId}`, 'GET');
	}

	async addComment(type, objectId, text) {
		return this.request(`/-/activity/${type}/${objectId}/comment`, 'POST', { text });
	}

}
